import React, { useState, useEffect } from 'react'

const Modal = ({ isOpen, onClose, documentData, title }) => {
    const [isImage, setIsImage] = useState(false);
    const [documentUrl, setDocumentUrl] = useState("");

    useEffect(() => {
        if (documentData) {
            const url = Object.values(documentData)[0];
            setDocumentUrl(url);
            
            // Check if the URL is an image
            const isImageUrl = url.match(/\.(jpeg|jpg|gif|png)$/i) !== null;
            setIsImage(isImageUrl);
        }
    }, [documentData]);


    console.log("documentDatadocumentDatadocumentData",documentUrl)

    if (!isOpen) return null;
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-11/12 max-w-4xl">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">{title || "Document"}</h2>
                    <button 
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        ✕
                    </button>
                </div>
                
                <div className="mb-4">
                    {documentData && (
                        <div className="flex flex-col items-center">
                            {isImage ? (
                                <img 
                                    src={documentUrl} 
                                    alt={title || "Document"} 
                                    className="max-w-full max-h-[70vh] object-contain border border-gray-200 rounded"
                                />
                            ) : (
                                <div className="text-center">
                                    <p className="mb-4">This document appears to be a PDF and cannot be displayed directly.</p>
                                    <a 
                                        href={documentUrl} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 inline-flex items-center"
                                    >
                                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                                        </svg>
                                        Open Document
                                    </a>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                
                <div className="flex justify-end mt-4">
                    <button
                        onClick={onClose}
                        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Modal